import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldDropdownV2 from 'src/components/FormComponents/FieldDropdownV2'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { selectFulfillmentCenters } from 'src/features/selector'
import { actions as appActions } from 'src/features/state'
import { FulfillmentCenter } from 'src/features/types'
import { actions } from '../../StockMovementsState'
import { MovementsFilters } from '../../StockMovementsTypes'
import { defaultFCValue, typeOptions } from './MovementForm.data'
import { schema } from './MovementForm.schema'
import { objectFilterByValue } from './objectFilterByValue'
import * as S from './MovementForm.styles'

export default () => {
  const {
    control,
    handleSubmit,
  } = useForm<MovementsFilters>({
    resolver: yupResolver(schema),
  })
  const dispatch = useDispatch()

  const fcs = useSelector(selectFulfillmentCenters)

  useEffect(() => {
    dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  const onSubmit: SubmitHandler<MovementsFilters> = (filters) => {
    const validFilters = objectFilterByValue<MovementsFilters>(filters, '0')
    dispatch(actions.setFilters(validFilters))
    dispatch(actions.resetMovements())
    dispatch(actions.getMovements())
  }

  const prepareFcs = (_fcs: FulfillmentCenter[]) => {
    const options = _fcs.map((fc) => ({ value: fc.id, label: fc.name }))
    return [{ value: defaultFCValue, label: 'Todos' }, ...options]
  }

  return (
    <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
      <S.Field
        as={FieldDropdownV2}
        labelText='Fulfillment Center'
        name='fulfillmentCenterId'
        defaultValue={defaultFCValue.toString()}
        control={control}
        options={prepareFcs(fcs)}
      />
      <S.Field
        as={FieldV2}
        labelText='Data inicio:'
        name='startDate'
        control={control}
        type='date'
      />
      <S.Field
        as={FieldV2}
        labelText='Data fim:'
        name='endDate'
        control={control}
        type='date'
      />
      <S.Field
        as={FieldV2}
        labelText='ID Modelo'
        name='modelId'
        control={control}
        type='number'
      />
      <S.Field
        as={FieldV2}
        labelText='Descrição'
        name='description'
        control={control}
        type='string'
      />
      <S.Field
        as={FieldDropdownV2}
        labelText='Tipo'
        name='type'
        defaultValue='0'
        control={control}
        options={typeOptions}
      />
      <S.Field
        as={FieldV2}
        labelText='Sistema de Origem'
        name='sourceSystem'
        control={control}
        type='string'
      />
      <S.Field
        as={FieldV2}
        labelText='Código do Produto'
        name='code'
        control={control}
        type='string'
      />
      <S.Field
        as={FieldV2}
        labelText='Usuário'
        name='user'
        control={control}
        type='string'
      />
      <S.Submit as={Submit} disabled={false} text='Buscar' />
    </S.Form>
  )
}
